// Shared with the CSS so overflow accounts for each control and group divider.
export const TOOLBAR_ITEM_WIDTH = 32;
export const TOOLBAR_GROUP_GAP = 17;

export const startsToolbarGroup = (items, index) => index > 0 && items[index - 1].group !== items[index].group;

export function getVisibleToolbarItemCount(items, availableWidth) {
  const itemWidths = items.map((item, index) =>
    TOOLBAR_ITEM_WIDTH + (startsToolbarGroup(items, index) ? TOOLBAR_GROUP_GAP : 0),
  );
  if (itemWidths.reduce((sum, width) => sum + width, 0) <= availableWidth) return items.length;

  // Once anything overflows, reserve a full control for the three-dot button.
  const budget = Math.max(0, availableWidth - TOOLBAR_ITEM_WIDTH);
  let used = 0;
  let count = 0;
  while (count < items.length && used + itemWidths[count] <= budget) {
    used += itemWidths[count];
    count += 1;
  }
  return count;
}
